import { FC, PropsWithChildren } from "react";
import "./CircularWrapper.scss";
import cn from "classnames";

export type CircularWrapperSize = "FillWidth" | "Small";

export interface Props {
  size?: CircularWrapperSize;
}
/**
 * @param param0 This component expects a rectangular image
 */
const CircularWrapper: FC<PropsWithChildren<Props>> = ({ children, size }) => (
  <div
    className={cn("circular-wrapper-norad", {
      "circular-wrapper-norad--fill-width": size === "FillWidth",
      "circular-wrapper-norad--small": size === "Small",
    })}
  >
    {children}
  </div>
);

export default CircularWrapper;
